const defer = function() {
  const result = {};
  result.promise = new Promise(function(resolve, reject) {
    result.resolve = resolve;
    result.reject = reject;
  });
  return result;
};

let promise = null;

window.recaptchaLoaded = function() {
  promise.resolve();
};

function loadRecaptcha() {
  if (promise) {
    return promise.promise;
  }
  promise = defer();

  let script_tag = document.createElement('script');
  script_tag.setAttribute("type", "text/javascript");
  const src = "https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit";
  script_tag.setAttribute("src", src);
  script_tag.setAttribute("async", 'async');
  script_tag.setAttribute("defer", 'defer');
  script_tag.setAttribute("id", 'grecaptcha');
  (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
  return promise.promise;
}

export {
  loadRecaptcha
}



// WEBPACK FOOTER //
// ./resources/assets/js/grecaptcha.js